import { t } from "i18next";
import NavbarReturnBody from "./NavbarReturnBody";
import downloadIcon from '../../assets/icons/download-icon-white.svg'
import { ButtonWhite } from "../Buttons/ButtonWhite";
import { useParams } from "react-router-dom";
import { getReportsTypes } from "../../components/Reports/ReportsTypes";
import useWindowSize from "../../customHooks/useWindowSize";
import { useContext } from "react";
import EntryAndDepartureReportContext from "../../context/EntryAndDepartureReportContext/EntryAndDepartureReportContext";
import PermanenceReportContext from "../../context/PermanenceReportContext/PermanenceReportContext";
import { Spinner } from "reactstrap";
import { havePermission } from "../../helpers/helpers";
import PermanenceTotals from "../Permanence/PermanenceTotals/PermanenceTotals";

const NavReportsBody = () => {

    const { reportType } = useParams();

    const getReportType = (value) => getReportsTypes().types.find(el => el.redirection === value);

    const { windowWidth } = useWindowSize();

    const alingment = !reportType ? 'justify-content-between' : 'justify-content-between justify-content-sm-start gap-2'

    const { downloadEntriesAndDeparturesReport, entryAndDepartureReportState } = useContext(EntryAndDepartureReportContext);
    const { entriesAndDeparturesPaginated } = entryAndDepartureReportState;

    const { permanenceReportState, downloadPermanenceReport } = useContext(PermanenceReportContext);
    const { totalReport, isFetchingTotalsReports, isDownloadingReport, reports } = permanenceReportState;

    const downloadFunctionByReports = {
        entryAndDeparture: downloadEntriesAndDeparturesReport,
        permanence: downloadPermanenceReport
    }

    const disabledOptionsByReports = {
        entryAndDeparture: entriesAndDeparturesPaginated.length === 0,
        permanence: reports.length === 0
    }

    const disabled = disabledOptionsByReports[reportType];

    const functionToDownload = () => downloadFunctionByReports[reportType]();

    return (
        <div>
            <NavbarReturnBody
                title={reportType ? getReportType(reportType).title : t('REQUESTS')}
                returnTo={-1} // -1 is the previous route
                alingment={alingment}
                iconOrText={
                    (windowWidth <= 576 && reportType && havePermission(7)) && (
                        <ButtonWhite className="p-0" disabled={disabled}>
                            {
                                isDownloadingReport ?
                                    <Spinner color="light" />
                                    :
                                    <img src={downloadIcon} alt="download" onClick={functionToDownload} />
                            }
                        </ButtonWhite>
                    )
                }
            />
            {(windowWidth <= 576 && reportType === 'permanence') && (
                <div className="mt-3">
                    <PermanenceTotals
                        totals={totalReport}
                        isFetching={isFetchingTotalsReports}
                    />
                </div>
            )}
        </div>
    )
}

export default NavReportsBody;